<template>
  <div
    class="screen_body"
    :class="bodyBg"
    :style="bgStyle"
    v-loading.fullscreen.lock="loading"
    :element-loading-text="this.$config.loadingText"
    :element-loading-spinner="this.$config.loadingSpinner"
    :element-loading-background="this.$config.loadingBackground"
  >
    <div class="screen_content">
      <div class="screen_content_center" v-if="screenFlow.StepId === '1'">
        <div class="screen_main_01">
          <!-- <span>{{ sponsorInfo.VoteName }}</span> -->
          <!-- <div v-html="sponsorInfo.VoteName"></div> -->
        </div>
      </div>
      <div
        class="screen_content_center"
        v-if="screenFlow.StepId === '2' || screenFlow.StepId === '4'"
      >
        <div class="screen_main_01">
          <div>
            {{ voteProjectInfo.ProjectName }}
          </div>
          <div class="remark">
            {{ voteProjectInfo.ProjectRemark }}
          </div>
          <div
            class="screen_main_score_item"
            v-if="calculateScore.ProjectBasicScore && screenFlow.StepId === '4'"
          >
            初赛得分：
            <span>
              {{ calculateScore.ProjectBasicScoreText }}
            </span>
          </div>
          <div
            class="screen_main_score_item"
            v-if="screenFlow.StepId === '4' && calculateScore.ProjectBasicScore"
          >
            决赛得分：
            <span>
              {{ calculateScore.ProjectAverageScoreText }}
            </span>
          </div>
          <div class="screen_main_score" v-if="voteProjectInfo.TotalScore">
            最终得分：
            <span>
              {{ voteProjectInfo.TotalScoreText }}
            </span>
            分
            <a title="分数详细信息" @click="openScoreDetail">
              <i class="iconfont icon-xinzenggongshi"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="screen_main_02" v-if="screenFlow.StepId === '3'">
        <h1>{{ voteJudgeInfo.ProjectName }}</h1>
        <div class="jury">
          <div class="jury-finish">已评：{{ voteJudgeInfo.VotedNum }}人</div>
          <div class="jury-unfinish">未评：{{ voteJudgeInfo.NoVoteNum }}人</div>
        </div>
        <div class="result-show" :class="juryItemClass">
          <div
            class="result-show-item"
            v-for="(judgeitem, index) in voteJudgeInfo.ScreenVoteJudgeList"
            :key="index"
          >
            <div class="item-img">
              <img
                :src="judgeitem.JudgePhoto"
                v-if="
                  !judgeitem.IsHigh && !judgeitem.IsLow && judgeitem.JudgePhoto
                "
              />
              <img
                :src="defaultJudgePhoto"
                v-if="
                  !judgeitem.IsHigh && !judgeitem.IsLow && !judgeitem.JudgePhoto
                "
              />
              <img :src="removeMaxPhoto" v-if="judgeitem.IsHigh" />
              <img :src="removeMinPhoto" v-if="judgeitem.IsLow" />
            </div>
            <div class="item-name">{{ judgeitem.JudgeName }}</div>
            <div
              :class="{
                'item-number-delete': judgeitem.IsHigh || judgeitem.IsLow,
                'item-number': !judgeitem.IsHigh && !judgeitem.IsLow
              }"
            >
              {{ judgeitem.JudgeScoreText }}
            </div>
          </div>
        </div>
      </div>
      <div
        :class="[
          'screen_main_03',
          (groupRankingInfo.ScreenVoteGroupRankingList?.length ?? 0) <= 10
            ? 'screen_main_03_few_num'
            : 'screen_main_03_large_num'
        ]"
        v-if="screenFlow.StepId === '5'"
      >
        <h1>{{ groupRankingInfo.GroupName }}</h1>
        <div
          class="ranking ranking_box"
          v-if="
            (groupRankingInfo.ScreenVoteGroupRankingList?.length ?? 0) <= 10
          "
        >
          <table>
            <tr
              v-for="(
                item, index
              ) in groupRankingInfo.ScreenVoteGroupRankingList"
              :key="index"
            >
              <td>
                <div class="ranking-first ranking-item-top">
                  <div class="ranking-top">
                    <div class="ranking-ranking">
                      <img
                        :src="
                          require('../../../../assets/images/screen_first.png')
                        "
                        v-if="
                          index === 0 && groupRankingInfo.IsShowGroupRankingIcon
                        "
                        v-show="index < groupRankingInfo.VoteScreenRankingNum"
                      />
                      <img
                        :src="
                          require('../../../../assets/images/screen_second.png')
                        "
                        v-if="
                          index === 1 && groupRankingInfo.IsShowGroupRankingIcon
                        "
                        v-show="index < groupRankingInfo.VoteScreenRankingNum"
                      />
                      <img
                        :src="
                          require('../../../../assets/images/screen_third.png')
                        "
                        v-if="
                          index === 2 && groupRankingInfo.IsShowGroupRankingIcon
                        "
                        v-show="index < groupRankingInfo.VoteScreenRankingNum"
                      />
                      <div class="rankingIndex" v-if="index > 2"></div>
                      <div
                        v-show="index < groupRankingInfo.VoteScreenRankingNum"
                      >
                        <span
                          v-show="groupRankingInfo.GroupRankingIndexType === 0"
                        >
                          第{{ item.RankNum }}名：
                        </span>
                        <span
                          v-show="groupRankingInfo.GroupRankingIndexType === 1"
                        >
                          {{ getGroupRankNum(index) }}、
                        </span>
                        <span
                          v-show="groupRankingInfo.GroupRankingIndexType === 2"
                        >
                          {{ item.RankNum }}、
                        </span>
                      </div>
                    </div>
                    <div class="ranking-project">{{ item.ProjectName }}</div>
                  </div>
                  <div class="ranking-company">
                    <div class="name">{{ item.ProjectRemark }}</div>
                    <div class="score" v-if="item.ProjectTotalScore">
                      <div class="scoreInfo" v-if="item.BasicScore">
                        {{
                          '（' +
                          item.BasicScoreText +
                          ' + ' +
                          item.AverageScoreText +
                          '）'
                        }}
                      </div>
                      <div>
                        得分：<span>{{ item.ProjectTotalScoreText }}</span> 分
                      </div>
                    </div>
                    <div class="score" v-if="!item.ProjectTotalScore">
                      得分：未打分
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>
          <div style="height: 1.5rem"></div>
        </div>
        <div
          class="ranking-lg ranking_box-lg"
          v-if="(groupRankingInfo.ScreenVoteGroupRankingList?.length ?? 0) > 10"
        >
          <table>
            <tr
              v-for="groupRankingRow in groupRankingRowCount"
              :key="groupRankingRow"
            >
              <!-- groupRankingInfo.ScreenVoteGroupRankingList -->
              <td>
                <div class="ranking-first ranking-item-top-lg">
                  <div class="ranking-top-lg">
                    <div class="ranking-ranking-lg">
                      <img
                        :src="
                          require('../../../../assets/images/screen_first.png')
                        "
                        v-if="
                          groupRankingRow - 1 === 0 &&
                          groupRankingInfo.IsShowGroupRankingIcon
                        "
                        v-show="
                          groupRankingRow - 1 <
                          groupRankingInfo.VoteScreenRankingNum
                        "
                      />
                      <img
                        :src="
                          require('../../../../assets/images/screen_second.png')
                        "
                        v-if="
                          groupRankingRow - 1 === 1 &&
                          groupRankingInfo.IsShowGroupRankingIcon
                        "
                        v-show="
                          groupRankingRow - 1 <
                          groupRankingInfo.VoteScreenRankingNum
                        "
                      />
                      <img
                        :src="
                          require('../../../../assets/images/screen_third.png')
                        "
                        v-if="
                          groupRankingRow - 1 === 2 &&
                          groupRankingInfo.IsShowGroupRankingIcon
                        "
                        v-show="
                          groupRankingRow - 1 <
                          groupRankingInfo.VoteScreenRankingNum
                        "
                      />
                      <div
                        class="rankingIndex-lg"
                        v-if="groupRankingRow - 1 > 2"
                      ></div>
                      <div
                        v-show="
                          groupRankingRow - 1 <
                          groupRankingInfo.VoteScreenRankingNum
                        "
                      >
                        <span
                          v-show="groupRankingInfo.GroupRankingIndexType === 0"
                        >
                          第{{
                            groupRankingInfo.ScreenVoteGroupRankingList[
                              groupRankingRow - 1
                            ].RankNum
                          }}名：
                        </span>
                        <span
                          v-show="groupRankingInfo.GroupRankingIndexType === 1"
                        >
                          {{ getGroupRankNum(groupRankingRow - 1) }}、
                        </span>
                        <span
                          v-show="groupRankingInfo.GroupRankingIndexType === 2"
                        >
                          {{
                            groupRankingInfo.ScreenVoteGroupRankingList[
                              groupRankingRow - 1
                            ].RankNum
                          }}、
                        </span>
                      </div>
                    </div>
                    <div class="ranking-project-lg">
                      {{
                        groupRankingInfo.ScreenVoteGroupRankingList[
                          groupRankingRow - 1
                        ].ProjectName
                      }}
                    </div>
                  </div>
                  <div class="ranking-company-lg">
                    <div class="name-lg">
                      {{
                        groupRankingInfo.ScreenVoteGroupRankingList[
                          groupRankingRow - 1
                        ].ProjectRemark
                      }}
                    </div>
                    <div
                      class="score-lg"
                      v-if="
                        groupRankingInfo.ScreenVoteGroupRankingList[
                          groupRankingRow - 1
                        ].ProjectTotalScore
                      "
                    >
                      <div
                        class="scoreInfo-lg"
                        v-if="
                          groupRankingInfo.ScreenVoteGroupRankingList[
                            groupRankingRow - 1
                          ].BasicScore
                        "
                      >
                        {{
                          '（' +
                          groupRankingInfo.ScreenVoteGroupRankingList[
                            groupRankingRow - 1
                          ].BasicScoreText +
                          ' + ' +
                          groupRankingInfo.ScreenVoteGroupRankingList[
                            groupRankingRow - 1
                          ].AverageScoreText +
                          '）'
                        }}
                      </div>
                      <div>
                        得分：<span>{{
                          groupRankingInfo.ScreenVoteGroupRankingList[
                            groupRankingRow - 1
                          ].ProjectTotalScoreText
                        }}</span>
                        分
                      </div>
                    </div>
                    <div
                      class="score-lg"
                      v-if="
                        !groupRankingInfo.ScreenVoteGroupRankingList[
                          groupRankingRow - 1
                        ].ProjectTotalScore
                      "
                    >
                      得分：未打分
                    </div>
                  </div>
                </div>
              </td>
              <td></td>
              <td>
                <div class="ranking-first ranking-item-top-lg">
                  <div class="ranking-top-lg">
                    <div class="ranking-ranking-lg">
                      <img
                        :src="
                          require('../../../../assets/images/screen_first.png')
                        "
                        v-if="
                          groupRankingRow + groupRankingRowCount - 1 === 0 &&
                          groupRankingInfo.IsShowGroupRankingIcon
                        "
                        v-show="
                          groupRankingRow + groupRankingRowCount - 1 <
                          groupRankingInfo.VoteScreenRankingNum
                        "
                      />
                      <img
                        :src="
                          require('../../../../assets/images/screen_second.png')
                        "
                        v-if="
                          groupRankingRow + groupRankingRowCount - 1 === 1 &&
                          groupRankingInfo.IsShowGroupRankingIcon
                        "
                        v-show="
                          groupRankingRow + groupRankingRowCount - 1 <
                          groupRankingInfo.VoteScreenRankingNum
                        "
                      />
                      <img
                        :src="
                          require('../../../../assets/images/screen_third.png')
                        "
                        v-if="
                          groupRankingRow + groupRankingRowCount - 1 === 2 &&
                          groupRankingInfo.IsShowGroupRankingIcon
                        "
                        v-show="
                          groupRankingRow + groupRankingRowCount - 1 <
                          groupRankingInfo.VoteScreenRankingNum
                        "
                      />
                      <div
                        class="rankingIndex-lg"
                        v-if="groupRankingRow + groupRankingRowCount - 1 > 2"
                      ></div>
                      <div
                        v-show="
                          groupRankingRow + groupRankingRowCount - 1 <
                          groupRankingInfo.VoteScreenRankingNum
                        "
                      >
                        <span
                          v-show="groupRankingInfo.GroupRankingIndexType === 0"
                        >
                          第{{
                            groupRankingInfo.ScreenVoteGroupRankingList[
                              groupRankingRow + groupRankingRowCount - 1
                            ].RankNum
                          }}名：
                        </span>
                        <span
                          v-show="groupRankingInfo.GroupRankingIndexType === 1"
                        >
                          {{
                            getGroupRankNum(
                              groupRankingRow + groupRankingRowCount - 1
                            )
                          }}、
                        </span>
                        <span
                          v-show="groupRankingInfo.GroupRankingIndexType === 2"
                        >
                          {{
                            groupRankingInfo.ScreenVoteGroupRankingList[
                              groupRankingRow + groupRankingRowCount - 1
                            ].RankNum
                          }}、
                        </span>
                      </div>
                    </div>
                    <div class="ranking-project-lg">
                      {{
                        groupRankingInfo.ScreenVoteGroupRankingList[
                          groupRankingRow + groupRankingRowCount - 1
                        ].ProjectName
                      }}
                    </div>
                  </div>
                  <div class="ranking-company-lg">
                    <div class="name-lg">
                      {{
                        groupRankingInfo.ScreenVoteGroupRankingList[
                          groupRankingRow + groupRankingRowCount - 1
                        ].ProjectRemark
                      }}
                    </div>
                    <div
                      class="score-lg"
                      v-if="
                        groupRankingInfo.ScreenVoteGroupRankingList[
                          groupRankingRow + groupRankingRowCount - 1
                        ].ProjectTotalScore
                      "
                    >
                      <div
                        class="scoreInfo-lg"
                        v-if="
                          groupRankingInfo.ScreenVoteGroupRankingList[
                            groupRankingRow + groupRankingRowCount - 1
                          ].BasicScore
                        "
                      >
                        {{
                          '（' +
                          groupRankingInfo.ScreenVoteGroupRankingList[
                            groupRankingRow + groupRankingRowCount - 1
                          ].BasicScoreText +
                          ' + ' +
                          groupRankingInfo.ScreenVoteGroupRankingList[
                            groupRankingRow + groupRankingRowCount - 1
                          ].AverageScoreText +
                          '）'
                        }}
                      </div>
                      <div>
                        得分：<span>{{
                          groupRankingInfo.ScreenVoteGroupRankingList[
                            groupRankingRow + groupRankingRowCount - 1
                          ].ProjectTotalScoreText
                        }}</span>
                        分
                      </div>
                    </div>
                    <div
                      class="score-lg"
                      v-if="
                        !groupRankingInfo.ScreenVoteGroupRankingList[
                          groupRankingRow + groupRankingRowCount - 1
                        ].ProjectTotalScore
                      "
                    >
                      得分：未打分
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>
          <div style="height: 1.5rem"></div>
        </div>
      </div>
      <div class="screen_main_04" v-if="screenFlow.StepId === '6'">
        <h1 style="letter-spacing: 0.2rem; text-indent: 0.2rem">颁奖典礼</h1>
        <h3>{{ groupRankingInfo.GroupName }}</h3>
        <div class="ranking ranking_box" v-if="screenFlow.StepId === '6'">
          <table>
            <tr
              v-for="(
                item, index
              ) in groupRankingInfo.ScreenVoteGroupRankingList"
              :key="index"
            >
              <td>
                <div class="ranking-first ranking-item">
                  <div class="ranking-top">
                    <div
                      class="ranking-ranking"
                      v-show="0 < groupRankingInfo.VoteScreenRankingNum"
                    >
                      <img
                        :src="
                          require('../../../../assets/images/screen_first.png')
                        "
                        v-if="index === 0"
                        v-show="index < groupRankingInfo.VoteScreenRankingNum"
                      />
                      <img
                        :src="
                          require('../../../../assets/images/screen_second.png')
                        "
                        v-if="index === 1"
                        v-show="index < groupRankingInfo.VoteScreenRankingNum"
                      />
                      <img
                        :src="
                          require('../../../../assets/images/screen_third.png')
                        "
                        v-if="index === 2"
                        v-show="index < groupRankingInfo.VoteScreenRankingNum"
                      />
                      <div
                        v-show="index < groupRankingInfo.VoteScreenRankingNum"
                      >
                        第{{ item.RankNum }}名：
                      </div>
                    </div>
                    <div class="ranking-project-01">{{ item.ProjectName }}</div>
                  </div>
                  <div
                    class="ranking-company-01"
                    :style="[
                      {
                        marginLeft:
                          groupRankingInfo.VoteScreenRankingNum > 0
                            ? '2.4rem'
                            : '0rem'
                      }
                    ]"
                  >
                    {{ item.ProjectRemark }}
                  </div>
                </div>
              </td>
            </tr>
          </table>
          <div style="height: 1.5rem"></div>
        </div>
      </div>
    </div>
    <!-- <div class="screen_foot" v-if="false">
      <h3 v-if="sponsorInfo.CompanyName">
        主办方：{{ sponsorInfo.CompanyName }}
      </h3>
      <h3>技术支持：北京鹏宇成软件技术有限公司</h3>
    </div> -->
    <el-dialog
      title="得分详细信息"
      :visible.sync="dialogVisible"
      width="50%"
      custom-class="score_detail_dialog"
    >
      <el-table
        :data="calculateScore.ScoreDetailList"
        :show-summary="
          calculateScore.WeightedCalculationType !== 'group_weighted_mean'
        "
        :summary-method="getSummaries"
      >
        <el-table-column
          property="UserName"
          label="投票人"
          min-width="25%"
        ></el-table-column>
        <el-table-column label="分数" min-width="55%" align="right">
          <template slot-scope="scope">
            <span
              style="color: red; font-style: oblique"
              v-if="scope.row.IsRemoveMaxScore"
            >
              -Max
            </span>
            <span
              style="color: red; font-style: oblique"
              v-if="scope.row.IsRemoveMinScore"
            >
              -Min
            </span>
            <span
              style="margin-left: 10px"
              :style="{
                textDecoration:
                  scope.row.IsRemoveMaxScore || scope.row.IsRemoveMinScore
                    ? 'line-through'
                    : 'none'
              }"
            >
              {{ scope.row.ScoreText }}
              *
              {{ scope.row.WeightText }}
              =
              {{ scope.row.WeightScoreText }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          property="WeightText"
          label="权重"
          min-width="20%"
          align="center"
        ></el-table-column>
      </el-table>
      <div
        class="detail_final_score"
        v-if="
          calculateScore.ProjectBasicScore &&
          calculateScore.WeightedCalculationType !== 'group_weighted_mean'
        "
      >
        最终得分： ({{ calculateScore.TotalScoreText }}
        /
        {{ calculateScore.TotalWeightText }}) +
        {{ calculateScore.ProjectBasicScoreText }}（基础得分） =
        <span>{{ calculateScore.FinalScoreText }}</span>
      </div>
      <div
        class="detail_final_score"
        v-if="
          !calculateScore.ProjectBasicScore &&
          calculateScore.WeightedCalculationType !== 'group_weighted_mean'
        "
      >
        最终得分：
        {{ calculateScore.TotalScoreText }}
        /
        {{ calculateScore.TotalWeightText }}
        =
        <span>{{ calculateScore.FinalScoreText }}</span>
      </div>
      <div
        class="detail_final_score"
        v-if="
          calculateScore.ProjectBasicScore &&
          calculateScore.WeightedCalculationType === 'group_weighted_mean'
        "
      >
        最终得分： ({{ calculateScore.GongShi }}) +
        {{ calculateScore.ProjectBasicScoreText }}（基础得分） =
        <span>{{ calculateScore.FinalScoreText }}</span>
      </div>
      <div
        class="detail_final_score"
        v-if="
          !calculateScore.ProjectBasicScore &&
          calculateScore.WeightedCalculationType === 'group_weighted_mean'
        "
      >
        最终得分： {{ calculateScore.GongShi }} =
        <span>{{ calculateScore.FinalScoreText }}</span>
      </div>
      <hr />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <div v-show="false">
      <audio ref="audio" id="audio" :src="audioUrl" loop="loop">
        您的浏览器不支持audio标签
      </audio>
      <el-button ref="btnPlay" @click="play">播放</el-button>
    </div>
  </div>
</template>

<script>
import screenApi from '../../../../api/mobileVote/screen' // screen投屏投票接口
import 'signalr'
import '../../../../assets/js/rem.js'
export default {
  data () {
    return {
      bodyBg: 'screen_body_default_bg',
      bgStyle: {
        backgroundImage: ''
      },
      defaultJudgePhoto: require('../../../../assets/images/judgePhoto.png'),
      removeMaxPhoto: require('../../../../assets/images/removeMax.png'),
      removeMinPhoto: require('../../../../assets/images/removeMin.png'),
      loading: false,
      screenFlow: {},
      sponsorInfo: {},
      voteProjectInfo: {},
      voteJudgeInfo: {},
      groupRankingInfo: {},
      groupRankingRowCount: 0,
      dialogVisible: false,
      calculateScore: {},
      juryItemClass: 'item10',
      conn: {},
      audioUrl: require('../../../../../public/audio/screen/颁奖曲.mp3')
    }
  },
  methods: {
    // 播放音频
    play () {
      const _this = this
      let actualVolumeFadeIn = 0
      _this.$refs.audio.volume = actualVolumeFadeIn
      _this.$refs.audio.play()
      const fadeInInterval = setInterval(function () {
        actualVolumeFadeIn = (parseFloat(actualVolumeFadeIn) + 0.05).toFixed(2)
        if (actualVolumeFadeIn <= 0.6) {
          _this.$refs.audio.volume = actualVolumeFadeIn
        } else {
          clearInterval(fadeInInterval)
        }
      }, 100)
      //   this.$refs.audio.play()
    },
    // 重播
    replay () {
      this.$refs.audio.load()
      this.$refs.audio.play()
    },
    pause () {
      this.$refs.audio.pause()
    },
    getScreenFlow: function () {
      this.loading = true
      screenApi.getScreenFlow({
        voteId: this.$route.params.vid
      }).then(data => {
        this.screenFlow = data
        this.connectionHub()
      }).catch(err => {
        this.loading = false
        return err
      })
    },
    getScreenVoteSponsorInfo: function () {
      const _this = this
      _this.loading = true
      screenApi.getScreenVoteSponsorInfo({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.loading = false
        _this.sponsorInfo = data
        if (_this.sponsorInfo.ScreenBodyBackground) {
          _this.bgStyle.backgroundImage = 'url(\'' + _this.sponsorInfo.ScreenBodyBackground + '\')'
        }
      }).catch(err => {
        _this.loading = false
        return err
      })
    },
    getScreenVoteProject: function () {
      const _this = this
      _this.loading = true
      screenApi.getScreenVoteProject({
        meetingId: _this.screenFlow.MeetingId,
        voteId: _this.screenFlow.VoteId,
        groupId: _this.screenFlow.GroupId,
        projectId: _this.screenFlow.ProjectId
      }).then(data => {
        _this.loading = false
        _this.voteProjectInfo = data
        screenApi.getScreenVoteCalculateScoreDetail({
          meetingId: _this.screenFlow.MeetingId,
          voteId: _this.screenFlow.VoteId,
          projectId: _this.screenFlow.ProjectId
        }).then(data => {
          _this.calculateScore = data
        }).catch(err => {
          return err
        })
      }).catch(err => {
        _this.loading = false
        return err
      })
    },
    getScreenVoteJudgeInfo: function () {
      const _this = this
      screenApi.getScreenVoteJudgeInfo({
        meetingId: _this.screenFlow.MeetingId,
        voteId: _this.screenFlow.VoteId,
        groupId: _this.screenFlow.GroupId,
        projectId: _this.screenFlow.ProjectId
      }).then(data => {
        _this.voteJudgeInfo = data
        if (_this.voteJudgeInfo.ScreenVoteJudgeList.length <= 10) {
          _this.juryItemClass = 'item10'
        }
        if (_this.voteJudgeInfo.ScreenVoteJudgeList.length > 10 && _this.voteJudgeInfo.ScreenVoteJudgeList.length <= 20) {
          _this.juryItemClass = 'item20'
        }
        if (_this.voteJudgeInfo.ScreenVoteJudgeList.length > 20 && _this.voteJudgeInfo.ScreenVoteJudgeList.length <= 30) {
          _this.juryItemClass = 'item30'
        }
        if (_this.voteJudgeInfo.ScreenVoteJudgeList.length > 30) {
          _this.juryItemClass = 'item40'
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        return err
      })
    },
    getGroupRankingInfo: function () {
      this.loading = true
      screenApi.getGroupRankingInfo({
        meetingId: this.screenFlow.MeetingId,
        voteId: this.screenFlow.VoteId,
        groupId: this.screenFlow.GroupId
      }).then(data => {
        this.loading = false
        this.groupRankingInfo = data
        this.groupRankingRowCount = Math.ceil((this.groupRankingInfo.ScreenVoteGroupRankingList || []).length / 2)
      }).catch(err => {
        this.loading = false
        return err
      })
    },
    screenFlowStepChange: function () {
      // MeetingId    GroupId    VoteId     ProjectId    StepId    IsBegin    IsSendMessage
      //   this.loading = true
      switch (this.screenFlow.StepId) {
        case '1': // 显示欢迎页面（不显示投票项目信息）
          this.$refs.audio.pause()
          this.bodyBg = 'screen_body_default_bg'
          //   this.bgStyle.backgroundImage = 'url(\'../../../../assets/images/screenBg_01.png\')'
          this.$nextTick(function () {
            this.getScreenVoteSponsorInfo()
          })
          break
        case '2':
          this.audioUrl = require('../../../../../public/audio/screen/上台音乐.mp3')
          this.$refs.audio.load()
          this.bodyBg = 'screen_body_score_bg'
          this.bgStyle.backgroundImage = ''
          this.$nextTick(function () {
            this.getScreenVoteProject()
          })
          break
        case '3':
          // this.$refs.audio.pause()
          this.bodyBg = 'screen_body_judge_bg'
          this.bgStyle.backgroundImage = ''
          this.$nextTick(function () {
            this.getScreenVoteJudgeInfo()
          })
          break
        case '4':
          // this.$refs.audio.pause()
          this.bodyBg = 'screen_body_score_bg'
          this.bgStyle.backgroundImage = ''
          this.$nextTick(function () {
            this.getScreenVoteProject()
          })
          break
        case '5':
          this.$refs.audio.pause()
          this.bodyBg = 'screen_body_groupRanking_bg'
          this.bgStyle.backgroundImage = ''
          this.$nextTick(function () {
            this.getGroupRankingInfo()
          })
          break
        case '6':
          this.audioUrl = require('../../../../../public/audio/screen/颁奖曲.mp3')
          this.$refs.audio.load()
          this.bodyBg = 'screen_body_ranking_bg'
          this.bgStyle.backgroundImage = ''
          this.$nextTick(function () {
            this.getGroupRankingInfo()
          })
          //   this.$refs.btnPlay.$el.click()
          break
        case '001':
          this.$refs.audio.pause()
          if (this.screenFlow.VoteType === 0) {
            this.$router.push({ name: 'shortlistedScreen', params: { vid: this.screenFlow.VoteId } })
          }
          if (this.screenFlow.VoteType === 3) {
            if (this.$route.params.vid === this.screenFlow.VoteId) {
              this.conn.stop()
              this.init()
            } else {
              this.loading = false
              this.$router.push({ name: 'largeScreen', params: { vid: this.screenFlow.VoteId } })
            }
          }
          break
        case '003':
          this.$refs.audio.pause()
          screenApi.getScreenFlow({
            voteId: this.$route.params.vid
          }).then(data => {
            this.screenFlow = data
            this.screenFlowStepChange()
          }).catch(err => {
            this.loading = false
            return err
          })
          break
        case '004':
          this.$refs.audio.pause()
          this.$router.push({ name: 'shortlistedScreen', params: { vid: this.screenFlow.VoteId } })
          break
      }
    },
    connectionHub: function () {
      const _this = this
      const voteId = _this.$route.params.vid
      const state = JSON.parse(window.localStorage.getItem('state'))
      const token = state.token
      const baseUrl = _this.$config.baseSite

      //   const conn = window.jQuery.hubConnection(baseUrl + '/signalr', { qs: 'access_token=' + token })
      // const conn = window.jQuery.hubConnection(baseUrl + '/signalr', { qs: 'access_token=' + '' })
      // const conn = window.jQuery.hubConnection(baseUrl, { qs: 'access_token=' + '' })
      _this.conn = window.jQuery.hubConnection(baseUrl, { qs: 'access_token=' + token })
      const chatHubProxy = _this.conn.createHubProxy('screenFlowHub')

      chatHubProxy.on('addRoom', function () {

      })

      _this.conn.start().done((data) => {
        chatHubProxy.invoke('addRoom', voteId)
          .done((data) => {
            _this.screenFlowStepChange()
            // this.$message({ showClose: true, type: 'success', message: '投票准备就绪' })
          })
          .fail((msg) => {
            _this.loading = false
            _this.$message({ showClose: true, type: 'error', message: '投票准备失败' })
          })
      }).fail((msg) => {
        _this.loading = false
        _this.$message({ showClose: true, type: 'error', message: '投票准备失败' })
      })

      _this.conn.error((error) => {
        console.log(error)
      })
      // 重新连接
      _this.conn.reconnected(() => {
        // console.log('重新连接')
      })
      // 当连接已断开连接
      _this.conn.disconnected(() => {
        // console.log('当连接已断开连接')
      })
      // 接收消息
      _this.conn.received((data) => {
        if (data.H && data.M && data.A) {
          if (data.H === 'ScreenFlowHub' && data.M === 'sendScreenFlow' && data.A) {
            const hubMessage = JSON.parse(data.A[0])
            if (hubMessage.StepId) {
              _this.screenFlow = JSON.parse(data.A[0])
              _this.screenFlowStepChange()
            }
            if (hubMessage.AudioOperate) {
              switch (hubMessage.AudioOperate) {
                case 'play':
                  if (_this.$refs.audio.paused) {
                    _this.$refs.btnPlay.$el.click()
                    // this.$refs.audio.play()
                  }
                  break
                case 'pause':
                  if (!_this.$refs.audio.paused) {
                    // const volumeArray = _this.$refs.audio.volume * 100
                    // console.log(volumeArray)
                    // for (let i = volumeArray; i >= 0; i--) {
                    //   setTimeout(function () {
                    //     _this.$refs.audio.volume = i * 0.01
                    //   }, 50)
                    // }
                    // _this.$refs.audio.animate({ volume: 0.1 }, 5000)
                    // _this.$refs.audio.pause()

                    let actualVolumeFadeOut = _this.$refs.audio.volume
                    const fadeOutInterval = setInterval(function () {
                      actualVolumeFadeOut = (parseFloat(actualVolumeFadeOut) - 0.05).toFixed(2)
                      if (actualVolumeFadeOut >= 0) {
                        _this.$refs.audio.volume = actualVolumeFadeOut
                      } else {
                        _this.$refs.audio.pause()
                        clearInterval(fadeOutInterval)
                      }
                    }, 80)
                  }
                  break
                case 'replay':
                  _this.replay()
                  break
                case 'changeVolume':
                  console.log(hubMessage.Volume)
                  if (hubMessage.Volume > _this.$refs.audio.volume) {
                    let volumeGradualChange = _this.$refs.audio.volume
                    const volumeGradualChangeInterval = setInterval(function () {
                      volumeGradualChange = (parseFloat(volumeGradualChange) + 0.1).toFixed(2)
                      if (volumeGradualChange <= hubMessage.Volume) {
                        _this.$refs.audio.volume = volumeGradualChange
                      } else {
                        clearInterval(volumeGradualChangeInterval)
                      }
                    }, 100)
                  } else {
                    let volumeGradualChange = _this.$refs.audio.volume
                    const volumeGradualChangeInterval = setInterval(function () {
                      volumeGradualChange = (parseFloat(volumeGradualChange) - 0.1).toFixed(2)
                      if (volumeGradualChange >= hubMessage.Volume) {
                        _this.$refs.audio.volume = volumeGradualChange
                      } else {
                        clearInterval(volumeGradualChangeInterval)
                      }
                    }, 100)
                  }
                  break
              }
            }
          }
        }
      })

      // 当客户端检测到慢速或频繁删除连接时引发
      _this.conn.connectionSlow(() => {
        // console.log('当客户端检测到慢速或频繁删除连接时引发')
      })
    },
    init: function () {
      this.getScreenFlow()
    },
    openScoreDetail: function () {
      const _this = this
      _this.dialogVisible = true
      screenApi.getScreenVoteCalculateScoreDetail({
        meetingId: this.screenFlow.MeetingId,
        voteId: _this.screenFlow.VoteId,
        projectId: _this.screenFlow.ProjectId
      }).then(data => {
        _this.calculateScore = data
      }).catch(err => {
        return err
      })
    },
    getSummaries (param) {
      const sums = []
      sums[0] = '合计'
      sums[1] = this.calculateScore.TotalScore
      sums[2] = this.calculateScore.TotalWeight
      return sums
    },
    getGroupRankNum (index) {
      if (index > 0) {
        if (this.groupRankingInfo.ScreenVoteGroupRankingList[index].ProjectTotalScore === this.groupRankingInfo.ScreenVoteGroupRankingList[index - 1].ProjectTotalScore && this.groupRankingInfo.ScreenVoteGroupRankingList[index].ProjectTotalScore) {
          this.groupRankingInfo.ScreenVoteGroupRankingList[index].RankNumNew = this.groupRankingInfo.ScreenVoteGroupRankingList[index - 1].RankNumNew
          return this.groupRankingInfo.ScreenVoteGroupRankingList[index - 1].RankNumNew
        } else {
          this.groupRankingInfo.ScreenVoteGroupRankingList[index].RankNumNew = this.groupRankingInfo.ScreenVoteGroupRankingList[index].RankNum
          return this.groupRankingInfo.ScreenVoteGroupRankingList[index].RankNumNew
        }
      } else {
        this.groupRankingInfo.ScreenVoteGroupRankingList[index].RankNumNew = this.groupRankingInfo.ScreenVoteGroupRankingList[index].RankNum
        return this.groupRankingInfo.ScreenVoteGroupRankingList[index].RankNumNew
      }
    }
  },
  mounted () {
    this.init()
  },
  created () {

  },
  beforeDestroy () {
    this.conn.stop()
  },
  watch: {
    $route () {
      this.init()
    }
  }
}
</script>

<style lang="less">
html,
body {
  height: 100%;
}

/* 图片自适应 */
img {
  width: 100%;
  height: auto;
  width: auto9; /* ie8 */
  display: block;
  -ms-interpolation-mode: bicubic; /*为了照顾ie图片缩放失真*/
}
img {
  border: none;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
}
.screen_body {
  width: 100%;
  height: 100%;
  font-family: SimSun, 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.screen_body_default_bg {
  background-repeat: no-repeat;
  background-image: url('../../../../assets/images/screenBg_01.png');
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.screen_body_judge_bg {
  background: url('../../../../assets/images/screenBg_03.png') no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.screen_body_score_bg {
  background: url('../../../../assets/images/screenBg_01.png') no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.screen_body_groupRanking_bg {
  background: url('../../../../assets/images/screenBg_04.png') no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.screen_body_ranking_bg {
  background: url('../../../../assets/images/screenBg_02.png') no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.screen_content {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
}

.screen_content_center {
  width: 100%;
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.screen_main {
  width: 100%;
  flex-grow: 2;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
.screen_main_01 {
  align-self: center;
  width: 12rem;
  font-size: 0.6rem;
  color: #fff;
  height: 5rem;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
}
.screen_main_01 .remark {
  padding: 50px 0px 0px 0px;
  font-size: 0.5rem;
  font-family: kaiti;
  flex-grow: 1;
}
.screen_main_02 {
  height: 100%;
  width: 14rem;
  margin: 0 auto;
  font-size: 0.5rem;
  color: #fff;
}
.screen_main_02 h1 {
  /* color: #fbfa7d; */
  font-size: 0.4rem;
  text-align: center;
  margin-top: 0.75rem;
  height: 1rem;
  line-height: 0.5rem;
}
.jury {
  display: flex;
  justify-content: space-between;
  width: 4.66rem;
  margin: 0.3rem auto;
}
.jury > div {
  font-size: 0.35rem;
}
.result-show {
  display: flex;
  flex-wrap: wrap;
}
.result-show-item {
  width: 1.5rem;
  height: 2.25rem;
  border: 1px dotted #acdbf5;
  margin: 0.1rem;
}
.result-show-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 0.3rem;
  font-size: 0.2rem;
  text-align: center;
}
.result-show-item img {
  width: 1.2rem;
}
.result-show-item .item-img {
  width: 1.2rem;
  height: 1.6rem;
  margin-top: 8px;
}
.result-show-item .item-name {
  width: 1.2rem;
  height: 0.3rem;
  background: #fff;
  color: #010101;
  font-family: 'microsoft yahei';
}
.result-show-item .item-number {
  width: 1.2rem;
  height: 0.3rem;
  color: #fff;
}
.result-show-item .item-number-delete {
  color: #f80b0b;
  text-decoration: line-through;
}
.item10 {
  width: 9rem;
  margin: 0 auto;
}
.item24 {
  width: 14rem;
  margin: 0 auto;
}
.item30 {
  width: 13.4rem;
  margin: 0 auto;
}
.item30 .result-show-item {
  width: 1.2rem;
  height: 2rem;
  border: 1px dotted #acdbf5;
  margin: 0.05rem;
}
.item30 .result-show-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 0.3rem;
  font-size: 0.2rem;
  text-align: center;
}
.item30 .result-show-item img {
  width: 1rem;
}
.item30 .result-show-item .item-img {
  width: 1rem;
  height: 1.33rem;
}
.item30 .result-show-item .item-name {
  width: 1rem;
  height: 0.3rem;
  background: #fff;
  color: #010101;
  font-family: 'microsoft yahei';
}
.item30 .result-show-item .item-number {
  width: 1rem;
  height: 0.3rem;
  color: #fff;
}
.result-show-item .item-number-delete {
  color: #f80b0b;
  text-decoration: line-through;
}
.item40 {
  width: 13.5rem;
  margin: 0 auto;
}
.item40 .result-show-item {
  width: 1rem;
  height: 1.62rem;
  border: 1px dotted #acdbf5;
  margin: 0.05rem;
}
.item40 .result-show-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 0.24rem;
  font-size: 0.16rem;
  text-align: center;
}
.item40 .result-show-item img {
  width: 0.8rem;
}
.item40 .result-show-item .item-img {
  width: 0.8rem;
  height: 1.07rem;
}
.item40 .result-show-item .item-name {
  width: 0.8rem;
  height: 0.24rem;
  background: #fff;
  color: #010101;
  font-family: 'microsoft yahei';
}
.item40 .result-show-item .item-number {
  width: 0.8rem;
  height: 0.24rem;
  color: #fff;
}
.result-show-item .item-number-delete {
  color: #f80b0b;
  text-decoration: line-through;
}

.screen_main_03 {
  height: 100%;
  margin: 0 auto;
  font-size: 0.5rem;
  color: #fff;
  padding: 0 1rem;
  font-family: simhei, 'times new roman';
}

.screen_main_03_few_num {
  width: 13rem;
}
.screen_main_03_few_num h1 {
  /* color: #fbfa7d; */
  font-size: 0.7rem;
  text-align: center;
  margin-top: 0.7rem;
}

.screen_main_03_large_num {
  width: 90%;
  padding: 0 0;
}
.screen_main_03_large_num h1 {
  /* color: #fbfa7d; */
  font-size: 0.7rem;
  text-align: center;
  margin-top: 0.61rem;
}

.screen_main_04 {
  height: 100%;
  width: 12.6rem;
  margin: 0 auto;
  font-size: 0.5rem;
  color: #fff;
  padding: 0 1rem;
  font-family: simhei, 'times new roman';
}
.screen_main_04 h1 {
  color: #fbfa7d;
  font-size: 0.7rem;
  text-align: center;
  margin-top: 0.9rem;
}
.screen_main_04 h3 {
  color: #fff;
  font-size: 0.46rem;
  text-align: center;
  margin-top: 0.3rem;
}
.screen_main_03 .ranking_box {
  height: e('calc(100% - 2.2rem)');
  cursor: default;
}
.screen_main_03 .ranking_box:hover {
  height: e('calc(100% - 2.2rem)');
  cursor: default;
  background-color: rgba(255, 255, 255, 0.1);
  //opacity: 0.1;
  border-radius: 0.3em;
  box-shadow: 0 0 0 1px hsla(0, 0%, 100%, 0.1) inset,
    0 0.5em 1em rgba(0, 0, 0, 0.6);
  text-shadow: 0 1px 1px hsla(0, 0%, 100%, 0.1);
}
.screen_main_03 .ranking_box-lg {
  height: e('calc(100% - 1.8rem)');
  cursor: default;
}
.screen_main_03 .ranking_box-lg:hover {
  height: e('calc(100% - 1.8rem)');
  cursor: default;
  background-color: rgba(255, 255, 255, 0.1);
  //opacity: 0.1;
  border-radius: 0.3em;
  box-shadow: 0 0 0 1px hsla(0, 0%, 100%, 0.1) inset,
    0 0.5em 1em rgba(0, 0, 0, 0.6);
  text-shadow: 0 1px 1px hsla(0, 0%, 100%, 0.1);
}
.screen_main_04 .ranking_box {
  height: e('calc(100% - 3.3rem)');
  cursor: default;
}
.screen_main_04 .ranking_box:hover {
  height: e('calc(100% - 3.3rem)');
  cursor: default;
  background-color: rgba(255, 255, 255, 0.1);
  //opacity: 0.1;
  border-radius: 0.3em;
  box-shadow: 0 0 0 1px hsla(0, 0%, 100%, 0.1) inset,
    0 0.5em 1em rgba(0, 0, 0, 0.6);
  text-shadow: 0 1px 1px hsla(0, 0%, 100%, 0.1);
}
.ranking {
  padding: 0rem 0.3rem;
  overflow-y: auto;
  margin-top: 0.2rem;
  font-size: 0.4rem;
  color: #fff;
}
.ranking::-webkit-scrollbar {
  display: none; /*隐藏滚动条*/
}
.ranking table {
  margin: 0 auto;
}
.ranking img {
  width: 0.5rem;
}
.ranking-item {
  margin-top: 0.45rem;
}
.ranking-item-top {
  margin-top: 0.2rem;
}
.ranking-top {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0.05rem 0;
}
.ranking-ranking {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 2.4rem;
}
.ranking-ranking img {
  margin-right: 15px;
}
.ranking-ranking .rankingIndex {
  width: 60px;
}
.ranking-project {
  width: 10rem;
}
.ranking-company {
  display: flex;
  justify-content: space-between;
  font-size: 0.32rem;
  margin-left: 2.4rem;
  font-family: kaiti;
  font-weight: bold;
}
.ranking-company .name {
  padding-right: 10px;
}
.ranking-company .score {
  align-self: flex-end;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.ranking-company .score span {
  color: #f40c0c;
  font-size: 0.4rem;
}
.ranking-company .score .scoreInfo {
  font-size: 0.32rem;
  color: #f40c0c;
}

.ranking-lg {
  padding: 0rem 10px;
  overflow-y: auto;
  margin-top: 0rem;
  font-size: 0.23rem;
  color: #fff;
}
.ranking-lg::-webkit-scrollbar {
  display: none; /*隐藏滚动条*/
}
.ranking-lg table {
  margin: 0 0px;
  width: 100%;
}
.ranking-lg table tr td:first-of-type {
  width: 48%;
}
.ranking-lg table tr td:nth-of-type(2) {
  width: 4%;
}
.ranking-lg table tr td:last-of-type {
  width: 48%;
}
.ranking-lg img {
  width: 0.5rem;
}
.ranking-item-lg {
  margin-top: 0.45rem;
}
.ranking-item-top-lg {
  margin-top: 0.1rem;
}
.ranking-top-lg {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0.05rem 0;
}
.ranking-ranking-lg {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 0.5rem;
}
.ranking-ranking-lg img {
  margin-right: 15px;
}
.ranking-ranking-lg .rankingIndex-lg {
  width: 60px;
}
.ranking-project-lg {
  width: 100%;
}
.ranking-company-lg {
  display: flex;
  justify-content: space-between;
  font-size: 0.18rem;
  margin-left: 0.5rem;
  font-family: kaiti;
  font-weight: bold;
}
.ranking-company-lg .name-lg {
  padding-right: 10px;
}
.ranking-company-lg .score-lg {
  align-self: flex-end;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.ranking-company-lg .score-lg span {
  color: #f40c0c;
  font-size: 0.15rem;
}
.ranking-company-lg .score-lg .scoreInfo-lg {
  font-size: 0.32rem;
  color: #f40c0c;
}

.ranking-project-01 {
  max-width: 9rem;
}
.ranking-company-01 {
  font-size: 0.32rem;
  margin-left: 2.4rem;
  font-family: kaiti;
  font-weight: bold;
}
.screen_main_01 .screen_main_score_item {
  font-size: 0.4rem;
  width: 3.6rem;
  align-self: center;
  text-align: left;
  margin-left: 0.6rem;
  margin-bottom: 0.15rem;
}
.screen_main_01 .screen_main_score_item span {
  color: #f40c0c;
  font-weight: 700;
  font-family: cursive;
}

.screen_main_01 .screen_main_score {
  //padding: 150px 0px 0px 0px;
  text-align: center;
}
.screen_main_01 .screen_main_score span {
  color: #f40c0c;
  font-weight: 700;
  font-family: cursive;
}
.screen_main_01 .screen_main_score i {
  //font-size: 30px;
  font-size: 0.45rem;
  vertical-align: top;
  cursor: pointer;
}
.screen_foot {
  width: 100%;
  height: 100px;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.detail_final_score {
  width: 100%;
  text-align: right;
  margin: 15px 0px 0px;
  vertical-align: middle;
}
.detail_final_score span {
  font-size: 0.4rem;
  font-weight: 600;
}
.score_detail_dialog {
  font-size: 0.18px;
}
.score_detail_dialog .el-dialog__header .el-dialog__title {
  font-size: 0.3rem;
}
.score_detail_dialog .el-dialog__header button {
  font-size: 0.2rem;
}
.score_detail_dialog .el-dialog__body {
  font-size: 0.2rem;
}
.score_detail_dialog .el-dialog__body .el-table {
  font-size: 0.18rem;
}
.score_detail_dialog .el-dialog__footer button {
  font-size: 0.15rem;
}
</style>
